<template>
  <v-container fluid class="index-container">
    <front-navigation></front-navigation>
    
    <v-flex hidden-md-and-down>
      <public-main-slider></public-main-slider>
    </v-flex>
    
    <v-flex hidden-lg-and-up>
      <search></search>
    </v-flex>
    
    <br>
    
    <v-card flat>
      <v-tabs
        v-model="model"
        centered
        color="primary"
        slider-color="primary"
        grow
      >
        <v-tab :key="1">
          Activities
        </v-tab>
        <v-tab :key="2">
          Accommodation
        </v-tab>
        <v-tab :key="3">
          Camping
        </v-tab>
      </v-tabs>

      <v-tabs-items v-model="model">
        <v-tab-item :key="1">
          <v-card flat>
            <activities></activities>
          </v-card>
        </v-tab-item>
        
        <v-tab-item :key="2">
          <v-card flat>
            <accomodations></accomodations>
          </v-card>
        </v-tab-item>
        
        <v-tab-item :key="3">
          <v-card flat>
            <camp-sites></camp-sites>
          </v-card>
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-container>
</template>

<script>
import FrontNavigation from '../Repeated/FrontNavigation'
import PublicMainSlider from '../Repeated/Slider'
import Accomodations from '../Repeated/Accomodation'
import CampSites from '../Repeated/CampSites'
import Activities from '../Repeated/Activities'
import Search from '../Repeated/Search'

export default {
  name: 'index',
  components: {
    FrontNavigation,
    Search,
    Activities,
    CampSites,
    Accomodations,
    PublicMainSlider
  },
  data () {
    return {
      model: null
    }
  },
  created () {
    // Initialize user data in localStorage
    localStorage.setItem('user_data', JSON.stringify({
      currency: 'KES',
      type: 'GB601X10',
      first_name: '',
      last_name: '',
      email: '',
      phone: '',
      destination: '',
      check_in: '',
      check_out: '',
      session_id: 'Guest'
    }))
    localStorage.setItem('vehicle_data', JSON.stringify([]))
    localStorage.setItem('conservation_data', JSON.stringify([]))
    localStorage.setItem('facility_data', JSON.stringify([]))
    localStorage.setItem('activity_data', JSON.stringify([]))
  },
  sockets: {
    connect: function (myEvent) {
      // Socket connection handler
    },
    mpesa: function (data) {
      // Mpesa socket handler
    },
    customEmit: function (val) {
      console.log('this method was fired by the socket server. eg: io.emit("customEmit", data)')
    }
  },
  methods: {
    next () {
      const active = parseInt(this.active)
      this.active = (active < 2 ? active + 1 : 0).toString()
    }
  }
}
</script>

<style scoped>
.index-container {
  padding: 0;
}

.v-tab {
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
}

.v-tabs-bar {
  background-color: #f5f7fa;
}

.v-tab--active {
  color: #4361ee !important;
}

.v-slide-group__content {
  justify-content: center;
}

.v-tabs-slider-wrapper {
  color: #4361ee !important;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .v-tab {
    font-size: 14px;
    padding: 0 12px;
  }
}

@media (max-width: 600px) {
  .v-tab {
    font-size: 12px;
    padding: 0 8px;
  }
}
</style>
